import * as React from "react";
import styled from "styled-components";
// components
import VideoPlayer from "./components/video";
import GifPlayer from "./components/animatedImage";

const VideoWrapper = styled.div`
  position: relative;
  z-index: ${props => props.theme.zDefault};
`;

const VideoContent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
`;

export default function VideoContentComponent({
  block,
}: {
  block:
    | Vingle.ITypeAndDataInterface<"animated-image", Vingle.IAnimatedImage>
    | Vingle.ITypeAndDataInterface<"video", Vingle.IVideo>;
}) {
  let children;
  if (block.type === "animated-image") {
    children = <GifPlayer block={block.data} />;
  } else {
    children = <VideoPlayer block={block.data} />;
  }
  const { data } = block;
  return (
    <VideoWrapper
      style={{
        paddingTop: `${(data.height / data.width) * 100}%`,
      }}
    >
      <VideoContent>{children}</VideoContent>
    </VideoWrapper>
  );
}
